export default function Products() {
  const products = [
    {
      icon: 'ri-shield-check-line',
      name: 'VPN Application',
      description: 'Advanced encryption technology protecting your online privacy and securing your internet connection. Browse safely with military-grade security protocols and anonymous browsing capabilities across all networks.',
      bgColor: '#ECECEC'
    },
    {
      icon: 'ri-brush-line',
      name: 'Cleaner Application',
      description: 'Optimize your iOS device performance by removing junk files, clearing cache, and managing storage efficiently. Keep your device running smoothly with intelligent cleaning algorithms and real-time monitoring.',
      bgColor: '#F5F5F5'
    },
    {
      icon: 'ri-smartphone-line',
      name: 'Security Suite',
      description: 'Comprehensive mobile security solution combining multiple protection layers. Monitor app permissions, detect threats, and maintain complete control over your device security with our integrated platform.',
      bgColor: '#F5F5F5'
    }
  ];

  return (
    <section id="products" className="min-h-screen bg-white py-32 px-20">
      <div className="mb-20">
        <div className="text-[11px] uppercase tracking-[2px] text-gray-500 font-medium mb-4">
          / Our Solutions
        </div>
        <h3 className="text-[64px] font-extrabold text-[#0A0A0A] leading-[1.15]" style={{ fontFamily: 'Inter, sans-serif' }}>
          iOS Security<br />
          Applications
        </h3>
      </div>

      <div className="grid grid-cols-3 gap-8">
        {products.map((product, index) => (
          <div 
            key={index}
            className="rounded-2xl p-10 transition-transform duration-300 hover:scale-[1.02] cursor-pointer"
            style={{ backgroundColor: product.bgColor, minHeight: '420px' }}
          >
            <div className="w-16 h-16 flex items-center justify-center mb-8">
              <i className={`${product.icon} text-[64px] text-[#6B46C1]`} style={{ lineHeight: 1 }}></i>
            </div>
            <h4 className="text-[28px] font-semibold text-[#1A1A1A] mb-5">
              {product.name}
            </h4>
            <p className="text-[15px] text-[#555555] leading-[1.7]">
              {product.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}